import { createStandaloneToast, type UseToastOptions } from "@chakra-ui/react";
import { t } from "@lingui/macro";
import type { AppStore } from "@src/stores/AppStore";
import type { BaseStore } from "@src/stores/BaseStore";
import { theme } from "@src/theme";
import { ScreenTypeState } from "@src/utils/mobx/states/screen-type-state";
import { computed, makeObservable, observable } from "mobx";
import { CustomToast, type ToastAction } from "./CustomToast";
import { DialogsStore } from "./DialogsStore";

const { toast: chakraToast } = createStandaloneToast({ theme });

export class UIStore implements BaseStore {
  appStore: AppStore;
  onBackButtonClick?: () => Promise<void>;
  dialogs = new DialogsStore();
  screenType = new ScreenTypeState();

  @observable
  editorFileUploadMap = new Map<string, boolean>();

  constructor(appStore: AppStore) {
    makeObservable(this);
    this.appStore = appStore;
  }

  @computed
  get isEditorUploading(): boolean {
    let isUploading = false;

    for (const value of this.editorFileUploadMap.values()) {
      if (value !== true) continue;
      isUploading = true;
      break;
    }

    return isUploading;
  }

  toast(options: UseToastOptions & { actions?: ToastAction[] }) {
    chakraToast({
      render: (props) => (
        <CustomToast
          isClosable={options.isClosable}
          onClose={props.onClose}
          title={
            options.title ?? t`Something went wrong, please try again later.`
          }
          description={options.description}
          status={options.status}
          actions={options.actions}
        />
      ),
    });
  }
}
